import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BookingDetailItem = ({ iconname, label, value, value1, value2 }) => {
  return (
    <div className="flex items-center space-x-3">
      <FontAwesomeIcon icon={iconname} className="w-5 text-gray-400" />
      <div className="text-sm text-slate-700 font-bold w-36 font-body">
        {label}{" "}
      </div>
      <div className="flex">
        <div
          className={`${
            value1
              ? "text-green-600 text-sm w-60 truncate font-body capitalize font-bold"
              : "text-gray-700 text-sm w-60 truncate font-body capitalize"
          }`}
        >
          {value1 ? value1 : value}
          <span className="text-green-600 text-sm truncate font-body capitalize font-bold">
            {value2 ? `${value2}` : ""}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BookingDetailItem;
